/* ============================================================
   EVIA THEME — Main JavaScript
   Vanilla JS · No jQuery · Defer-loaded
   ============================================================ */

(function() {
  'use strict';

  // ==================== TOPBAR ROTATION ====================
  const topbarMsgs = document.querySelectorAll('.topbar-msg');
  if (topbarMsgs.length > 1) {
    let mi = 0;
    const interval = parseInt(document.body.dataset.topbarInterval || 3, 10) * 1000;
    setInterval(() => {
      topbarMsgs[mi].classList.remove('active');
      mi = (mi + 1) % topbarMsgs.length;
      topbarMsgs[mi].classList.add('active');
    }, interval);
  }

  // ==================== STICKY HEADER ====================
  const header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ==================== MOBILE NAV ====================
  const mobNav = document.getElementById('mobNav');
  const mobOverlay = document.getElementById('mobOverlay');
  const mobBtn = document.getElementById('mobNavBtn');
  const mobClose = document.getElementById('mobNavClose');
  const openMob = () => { mobNav?.classList.add('open'); mobOverlay?.classList.add('open'); };
  const closeMob = () => { mobNav?.classList.remove('open'); mobOverlay?.classList.remove('open'); };
  mobBtn?.addEventListener('click', openMob);
  mobClose?.addEventListener('click', closeMob);
  mobOverlay?.addEventListener('click', closeMob);

  // ==================== CART DRAWER ====================
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartCount = document.getElementById('cartCount');
  const cartItemsEl = document.getElementById('cdItems');
  const cartFootEl = document.getElementById('cdFoot');
  const cartSubtotalEl = document.getElementById('cdSubtotal');
  const shipFillEl = document.getElementById('shipFill');
  const shipMsgEl = document.getElementById('shipMsg');
  const FREE_SHIP_THRESHOLD = parseInt(document.body.dataset.freeShipThreshold || 5000, 10);

  function openCart() { cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); }
  function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); fetchCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });
  cartOverlay?.addEventListener('click', closeCart);

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      renderCart(cart);
      return cart;
    } catch (e) { console.warn('Cart fetch failed', e); return null; }
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    if (cartCount) cartCount.textContent = cart.item_count;
    document.body.classList.toggle('cart-has-items', cart.item_count > 0);

    if (cart.items.length === 0) {
      cartItemsEl.innerHTML = `
        <div class="cd-empty">
          <svg width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" style="margin:0 auto 12px;opacity:.35"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
          <p style="margin:0;font-size:14px">Your cart is empty</p>
          <p style="margin:8px 0 0;font-size:12px">Add some products to get started!</p>
        </div>`;
      if (cartFootEl) cartFootEl.style.display = 'none';
      updateShipBar(0);
      updateUpsell(cart);
      return;
    }

    cartItemsEl.innerHTML = cart.items.map(item => `
      <div class="cd-item" data-line-key="${item.key}">
        <div class="cdi-img"><a href="${item.url}"><img src="${item.image}" alt="${item.title}" loading="lazy"></a></div>
        <div style="flex:1">
          <div class="cdi-name"><a href="${item.url}">${item.product_title}</a></div>
          <div class="cdi-price">PKR ${(item.final_price / 100).toLocaleString()}</div>
          <div class="cdi-qty">
            <button class="qb" data-qty-minus aria-label="Decrease">−</button>
            <span class="qn">${item.quantity}</span>
            <button class="qb" data-qty-plus aria-label="Increase">+</button>
          </div>
        </div>
      </div>`).join('');

    if (cartFootEl) cartFootEl.style.display = 'block';
    if (cartSubtotalEl) cartSubtotalEl.textContent = `PKR ${(cart.total_price / 100).toLocaleString()}`;
    updateUpsell(cart);
    updateShipBar(cart.total_price / 100);
  }

  // Best-seller bundle upsell (snippets/cart-drawer.liquid): show only when the cart has
  // items and none of them is the bundle or one of its component products.
  function updateUpsell(cart) {
    const el = document.getElementById('cdUpsell');
    if (!el) return;
    const exclude = (el.dataset.excludeIds || '').split(',').filter(Boolean).map(Number);
    const hasOverlap = cart.items.some(i => exclude.includes(i.product_id));
    el.hidden = cart.items.length === 0 || hasOverlap;
  }

  function updateShipBar(subtotal) {
    const pct = Math.min(100, (subtotal / FREE_SHIP_THRESHOLD) * 100);
    const unlocked = subtotal >= FREE_SHIP_THRESHOLD;
    if (shipFillEl && shipMsgEl) {
      shipFillEl.style.width = pct + '%';
      shipMsgEl.textContent = unlocked
        ? "🎉 You've unlocked free shipping!"
        : `PKR ${(FREE_SHIP_THRESHOLD - subtotal).toLocaleString()} away from free shipping`;
    }
    // Site-wide bar (snippets/free-ship-bar.liquid) — same numbers, every page.
    const barEl = document.getElementById('shipBar');
    if (barEl) {
      const barFill = document.getElementById('shipBarFill');
      const barMsg = document.getElementById('shipBarMsg');
      if (barFill) barFill.style.width = pct + '%';
      if (barMsg) {
        barMsg.textContent = unlocked
          ? '🎉 You’ve unlocked free delivery'
          : `Add PKR ${(FREE_SHIP_THRESHOLD - subtotal).toLocaleString()} more for free delivery`;
      }
      barEl.classList.toggle('is-visible', subtotal > 0);
    }
  }

  document.addEventListener('click', async (e) => {
    const qtyMinus = e.target.closest('[data-qty-minus]');
    const qtyPlus = e.target.closest('[data-qty-plus]');
    if (!qtyMinus && !qtyPlus) return;
    const item = e.target.closest('[data-line-key]');
    const key = item?.dataset.lineKey;
    if (!key) return;
    const currentQty = parseInt(item.querySelector('.qn').textContent, 10);
    const newQty = qtyMinus ? currentQty - 1 : currentQty + 1;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty }),
        credentials: 'same-origin',
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (err) { console.warn('Cart change failed', err); }
  });

  // ==================== CART POPUP (mini cart at bottom) ====================
  const cartPopupEl = document.getElementById('cartPopup');
  let popupHideTimer = null;

  function showCartPopup(item, cart) {
    if (!cartPopupEl) return;
    const itemEl = document.getElementById('cartPopupItem');
    const imgEl = document.getElementById('cartPopupImg');
    const shipMsgEl = document.getElementById('cartPopupShipMsg');
    const shipBarEl = document.getElementById('cartPopupShipBar');
    if (itemEl) itemEl.textContent = item.product_title + (item.quantity > 1 ? ` × ${item.quantity}` : '');
    if (imgEl && item.image) imgEl.innerHTML = `<img src="${item.image}" alt="${item.product_title}">`;
    const subtotal = (cart?.total_price || 0) / 100;
    // Free shipping bar
    if (shipMsgEl) {
      if (subtotal >= FREE_SHIP_THRESHOLD) {
        shipMsgEl.textContent = "🎉 Free shipping unlocked!";
        shipBarEl?.classList.add('cart-popup__bar--won');
      } else {
        shipMsgEl.textContent = `Add PKR ${(FREE_SHIP_THRESHOLD - subtotal).toLocaleString()} more for FREE shipping`;
        shipBarEl?.classList.remove('cart-popup__bar--won');
      }
    }
    cartPopupEl.classList.add('visible');
    clearTimeout(popupHideTimer);
    popupHideTimer = setTimeout(hideCartPopup, 8000);
  }

  function hideCartPopup() {
    cartPopupEl?.classList.remove('visible');
    clearTimeout(popupHideTimer);
  }

  document.querySelectorAll('[data-cart-popup-close]').forEach(b => b.addEventListener('click', hideCartPopup));

  // ==================== PRODUCT ATC FORMS ====================
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const origText = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' });
      if (!res.ok) throw new Error('Add to cart failed');
      const item = await res.json();
      if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart', {
          content_ids: [item.product_id],
          content_name: item.product_title,
          value: item.final_price / 100,
          currency: 'PKR',
        });
      }
      if (btn) btn.textContent = '✓ Added!';
      const cart = await fetchCart();
      showCartPopup(item, cart);
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = origText; } }, 1800);
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = origText; }
      alert('Could not add to cart. Please try again.');
    }
  });

  // Quick add (e.g., from product cards)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    const origText = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }),
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('failed');
      const item = await res.json();
      btn.textContent = '✓ Added!';
      const cart = await fetchCart();
      showCartPopup(item, cart);
      setTimeout(() => { btn.disabled = false; btn.textContent = origText; }, 1800);
    } catch (err) {
      btn.disabled = false; btn.textContent = origText;
      alert('Could not add to cart.');
    }
  });

  // ==================== CONCERN PILLS ====================
  document.querySelectorAll('.concern-pill').forEach(p => {
    p.addEventListener('click', () => {
      document.querySelectorAll('.concern-pill').forEach(x => x.classList.remove('active'));
      p.classList.add('active');
    });
  });

  // ==================== REVIEW CAROUSEL ====================
  document.querySelectorAll('[data-carousel]').forEach(wrap => {
    const track = wrap.querySelector('[data-carousel-track]');
    wrap.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -300, behavior: 'smooth' }));
    wrap.querySelector('[data-carousel-next]')?.addEventListener('click', () => track?.scrollBy({ left: 300, behavior: 'smooth' }));
  });

  // ==================== ACCORDIONS ====================
  document.querySelectorAll('.accordion-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const isOpen = content.classList.contains('open');
      document.querySelectorAll('.accordion-content.open').forEach(c => c.classList.remove('open'));
      document.querySelectorAll('.accordion-trigger').forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (!isOpen) { content.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  // ==================== UGC TAP-TO-PLAY ====================
  document.querySelectorAll('[data-ugc-card]').forEach(card => {
    card.addEventListener('click', () => {
      const video = card.querySelector('video');
      if (!video) return;
      document.querySelectorAll('[data-ugc-card].playing').forEach(other => {
        if (other === card) return;
        const v = other.querySelector('video');
        if (v) { v.pause(); v.muted = true; }
        other.classList.remove('playing');
      });
      if (video.paused) {
        video.muted = false;
        video.play().catch(() => { video.muted = true; video.play(); });
        card.classList.add('playing');
      } else {
        video.pause();
        video.muted = true;
        card.classList.remove('playing');
      }
    });
  });

  // ==================== UGC CAROUSEL ====================
  document.querySelectorAll('.ugc-carousel').forEach(carousel => {
    const track = carousel.querySelector('.ugc-scroll');
    function scrollCards(dir) {
      const item = track.querySelector('.ugc-item');
      const step = item ? item.offsetWidth + 14 : 280;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    carousel.querySelector('.ugc-prev')?.addEventListener('click', () => scrollCards(-1));
    carousel.querySelector('.ugc-next')?.addEventListener('click', () => scrollCards(1));
  });

  // ==================== RECENT PURCHASE TOASTS ====================
  const PURCHASES = [
    { name: 'Ayesha', city: 'Lahore', product: 'Anti-Acne Facewash', time: '3 minutes ago' },
    { name: 'Zainab', city: 'Karachi', product: 'Exfoliating Toner', time: '7 minutes ago' },
    { name: 'Sana', city: 'Islamabad', product: 'Anti-Acne Duo', time: '12 minutes ago' },
    { name: 'Hira', city: 'Rawalpindi', product: 'SPF 50 Sunscreen', time: '5 minutes ago' },
    { name: 'Mahnoor', city: 'Faisalabad', product: 'Bright Boost Bundle', time: '18 minutes ago' },
    { name: 'Fatima', city: 'Lahore', product: 'Anti-Acne Facewash', time: '2 minutes ago' },
    { name: 'Rabia', city: 'Multan', product: 'Exfoliating Toner', time: '9 minutes ago' },
    { name: 'Noor', city: 'Karachi', product: 'Glass Skin Shield Set', time: '14 minutes ago' },
    { name: 'Amna', city: 'Lahore', product: 'SPF 50 Sunscreen', time: '6 minutes ago' },
    { name: 'Mehak', city: 'Islamabad', product: 'Lit Skin Kit Serum', time: '21 minutes ago' },
    { name: 'Iqra', city: 'Peshawar', product: 'Anti-Acne Facewash', time: '4 minutes ago' },
    { name: 'Sadia', city: 'Sialkot', product: 'Exfoliating Toner', time: '11 minutes ago' },
    { name: 'Areeba', city: 'Gujranwala', product: 'Anti-Acne Duo', time: '16 minutes ago' },
    { name: 'Bushra', city: 'Hyderabad', product: 'SPF 50 Sunscreen', time: '8 minutes ago' },
    { name: 'Rimsha', city: 'Quetta', product: 'Bright Boost Bundle', time: '23 minutes ago' },
    { name: 'Saima', city: 'Bahawalpur', product: 'Anti-Acne Facewash', time: '1 minute ago' },
    { name: 'Aiman', city: 'Sargodha', product: 'Exfoliating Toner', time: '19 minutes ago' },
    { name: 'Komal', city: 'Abbottabad', product: 'Glass Skin Shield Set', time: '27 minutes ago' },
    { name: 'Maryam', city: 'Rahim Yar Khan', product: 'SPF 50 Sunscreen', time: '10 minutes ago' },
    { name: 'Tayyaba', city: 'Sahiwal', product: 'Anti-Acne Facewash', time: '15 minutes ago' },
    { name: 'Hajra', city: 'Mardan', product: 'Lit Skin Kit Serum', time: '32 minutes ago' },
    { name: 'Uzma', city: 'Sukkur', product: 'Exfoliating Toner', time: '7 minutes ago' },
    { name: 'Farah', city: 'Larkana', product: 'Anti-Acne Duo', time: '38 minutes ago' },
    { name: 'Sobia', city: 'Dera Ghazi Khan', product: 'SPF 50 Sunscreen', time: '24 minutes ago' },
    { name: 'Rukhsar', city: 'Jhang', product: 'Bright Boost Bundle', time: '13 minutes ago' },
    { name: 'Nadia', city: 'Multan', product: 'Anti-Acne Facewash', time: '29 minutes ago' },
    { name: 'Asma', city: 'Faisalabad', product: 'SPF 50 Sunscreen', time: '17 minutes ago' },
    { name: 'Dur-e-Nayab', city: 'Karachi', product: 'Glass Skin Shield Set', time: '35 minutes ago' },
    { name: 'Warda', city: 'Lahore', product: 'Exfoliating Toner', time: '4 minutes ago' },
    { name: 'Mishal', city: 'Islamabad', product: 'Anti-Acne Facewash', time: '26 minutes ago' },
    { name: 'Muniba', city: 'Rawalpindi', product: 'Lit Skin Kit Serum', time: '40 minutes ago' },
    { name: 'Shanza', city: 'Peshawar', product: 'SPF 50 Sunscreen', time: '22 minutes ago' },
    { name: 'Anum', city: 'Sialkot', product: 'Anti-Acne Duo', time: '31 minutes ago' },
    { name: 'Zara', city: 'Gujranwala', product: 'Bright Boost Bundle', time: '8 minutes ago' },
    { name: 'Aliza', city: 'Kasur', product: 'Anti-Acne Facewash', time: '11 minutes ago' },
    { name: 'Nimra', city: 'Sheikhupura', product: 'Exfoliating Toner', time: '33 minutes ago' },
    { name: 'Kainat', city: 'Gujrat', product: 'Lit Skin Kit Serum', time: '45 minutes ago' },
    { name: 'Sumbul', city: 'Muzaffarabad', product: 'Anti-Acne Facewash', time: '6 minutes ago' },
    { name: 'Huma', city: 'Mirpur', product: 'SPF 50 Sunscreen', time: '20 minutes ago' },
    { name: 'Sheeza', city: 'Okara', product: 'Anti-Acne Duo', time: '42 minutes ago' },
    { name: 'Nayab', city: 'Chiniot', product: 'Exfoliating Toner', time: '14 minutes ago' },
    { name: 'Laiba', city: 'Hafizabad', product: 'Bright Boost Bundle', time: '37 minutes ago' },
    { name: 'Aroha', city: 'Narowal', product: 'Anti-Acne Facewash', time: '9 minutes ago' },
    { name: 'Sundas', city: 'Khanewal', product: 'Glass Skin Shield Set', time: '28 minutes ago' },
    { name: 'Bisma', city: 'Kasur', product: 'SPF 50 Sunscreen', time: '16 minutes ago' },
    { name: 'Palwasha', city: 'Nowshera', product: 'Exfoliating Toner', time: '51 minutes ago' },
    { name: 'Tooba', city: 'Kohat', product: 'Anti-Acne Facewash', time: '3 minutes ago' },
    { name: 'Misbah', city: 'Attock', product: 'Lit Skin Kit Serum', time: '44 minutes ago' },
    { name: 'Fiza', city: 'Chakwal', product: 'Anti-Acne Duo', time: '18 minutes ago' },
    { name: 'Rida', city: 'Jhelum', product: 'Bright Boost Bundle', time: '57 minutes ago' },
    { name: 'Iqra', city: 'Vehari', product: 'Anti-Acne Facewash', time: '30 minutes ago' },
    { name: 'Maira', city: 'Pakpattan', product: 'SPF 50 Sunscreen', time: '23 minutes ago' },
    { name: 'Zunaira', city: 'Bhakkar', product: 'Glass Skin Shield Set', time: '47 minutes ago' },
    { name: 'Samia', city: 'Mianwali', product: 'Exfoliating Toner', time: '12 minutes ago' },
    { name: 'Afshan', city: 'Khushab', product: 'Anti-Acne Duo', time: '36 minutes ago' },
    { name: 'Sahar', city: 'Toba Tek Singh', product: 'Anti-Acne Facewash', time: '5 minutes ago' },
    { name: 'Zoya', city: 'Kamalia', product: 'Lit Skin Kit Serum', time: '53 minutes ago' },
    { name: 'Rafia', city: 'Gojra', product: 'Bright Boost Bundle', time: '25 minutes ago' },
    { name: 'Sehrish', city: 'Jaranwala', product: 'SPF 50 Sunscreen', time: '39 minutes ago' },
    { name: 'Naila', city: 'Wah Cantt', product: 'Anti-Acne Facewash', time: '8 minutes ago' },
    { name: 'Taskeen', city: 'Taxila', product: 'Exfoliating Toner', time: '43 minutes ago' },
    { name: 'Shabnam', city: 'Haripur', product: 'Glass Skin Shield Set', time: '1 hour ago' },
    { name: 'Nosheen', city: 'Mansehra', product: 'Anti-Acne Duo', time: '55 minutes ago' },
    { name: 'Farwa', city: 'Battagram', product: 'Anti-Acne Facewash', time: '17 minutes ago' },
    { name: 'Nageen', city: 'Swat', product: 'SPF 50 Sunscreen', time: '34 minutes ago' },
    { name: 'Kinza', city: 'Mingora', product: 'Exfoliating Toner', time: '48 minutes ago' },
    { name: 'Adeeba', city: 'Dir', product: 'Bright Boost Bundle', time: '1 hour ago' },
    { name: 'Ambreen', city: 'Turbat', product: 'Anti-Acne Facewash', time: '21 minutes ago' },
    { name: 'Sumbal', city: 'Khuzdar', product: 'Lit Skin Kit Serum', time: '59 minutes ago' },
    { name: 'Maha', city: 'Hub', product: 'Anti-Acne Duo', time: '27 minutes ago' },
    { name: 'Asifa', city: 'Sukkur', product: 'SPF 50 Sunscreen', time: '46 minutes ago' },
    { name: 'Humaira', city: 'Nawabshah', product: 'Exfoliating Toner', time: '10 minutes ago' },
    { name: 'Shagufta', city: 'Mirpurkhas', product: 'Glass Skin Shield Set', time: '52 minutes ago' },
    { name: 'Ishrat', city: 'Jacobabad', product: 'Anti-Acne Facewash', time: '32 minutes ago' },
    { name: 'Mariyam', city: 'Shikarpur', product: 'Bright Boost Bundle', time: '15 minutes ago' },
    { name: 'Raheela', city: 'Hyderabad', product: 'SPF 50 Sunscreen', time: '41 minutes ago' },
    { name: 'Baseerat', city: 'Badin', product: 'Exfoliating Toner', time: '26 minutes ago' },
    { name: 'Samreen', city: 'Thatta', product: 'Anti-Acne Duo', time: '1 hour ago' },
    { name: 'Fariha', city: 'Lahore', product: 'Anti-Acne Facewash', time: '7 minutes ago' },
    { name: 'Areesha', city: 'Karachi', product: 'Lit Skin Kit Serum', time: '38 minutes ago' },
    { name: 'Duaa', city: 'Islamabad', product: 'SPF 50 Sunscreen', time: '13 minutes ago' },
    { name: 'Madiha', city: 'Rawalpindi', product: 'Bright Boost Bundle', time: '50 minutes ago' },
    { name: 'Hamza', city: 'Lahore', product: 'Anti-Acne Facewash', time: '19 minutes ago' },
    { name: 'Usman', city: 'Karachi', product: 'Exfoliating Toner', time: '44 minutes ago' },
    { name: 'Bilal', city: 'Islamabad', product: 'Anti-Acne Duo', time: '6 minutes ago' },
    { name: 'Ahsan', city: 'Faisalabad', product: 'SPF 50 Sunscreen', time: '28 minutes ago' },
    { name: 'Zubair', city: 'Multan', product: 'Bright Boost Bundle', time: '1 hour ago' },
    { name: 'Salman', city: 'Peshawar', product: 'Anti-Acne Facewash', time: '35 minutes ago' },
    { name: 'Imran', city: 'Rawalpindi', product: 'Glass Skin Shield Set', time: '55 minutes ago' },
    { name: 'Fahad', city: 'Sialkot', product: 'Lit Skin Kit Serum', time: '22 minutes ago' },
    { name: 'Kamran', city: 'Gujranwala', product: 'Anti-Acne Facewash', time: '48 minutes ago' },
    { name: 'Arslan', city: 'Quetta', product: 'SPF 50 Sunscreen', time: '11 minutes ago' },
    { name: 'Aqib', city: 'Hyderabad', product: 'Exfoliating Toner', time: '37 minutes ago' },
    { name: 'Talha', city: 'Bahawalpur', product: 'Anti-Acne Duo', time: '4 minutes ago' },
    { name: 'Omer', city: 'Sargodha', product: 'Bright Boost Bundle', time: '52 minutes ago' },
    { name: 'Hassan', city: 'Abbottabad', product: 'Anti-Acne Facewash', time: '16 minutes ago' },
  ];
  const toast = document.getElementById('rpToast');
  let lastIdx = -1;
  function randomTime() {
    const r = Math.random();
    if (r < 0.52) {
      const m = Math.floor(Math.random() * 56) + 2;
      return m + ' minutes ago';
    } else if (r < 0.75) {
      return '1 hour ago';
    } else if (r < 0.88) {
      return '2 hours ago';
    } else if (r < 0.94) {
      return '3 hours ago';
    } else if (r < 0.97) {
      return '4 hours ago';
    } else {
      return Math.floor(Math.random() * 2 + 5) + ' hours ago';
    }
  }
  function showToast() {
    if (!toast) return;
    let i; do { i = Math.floor(Math.random() * PURCHASES.length); } while (i === lastIdx);
    lastIdx = i;
    const p = PURCHASES[i];
    const nameEl = document.getElementById('toastName');
    const metaEl = document.getElementById('toastMeta');
    if (nameEl) nameEl.textContent = `${p.name} from ${p.city}`;
    if (metaEl) metaEl.textContent = `${p.product} · ${randomTime()}`;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 5000);
    setTimeout(showToast, 45000 + Math.random() * 45000);
  }
  if (toast) {
    const delay = parseInt(document.body.dataset.toastDelay || 8, 10) * 1000;
    setTimeout(showToast, delay);
  }

  // ==================== LIVE VISITOR COUNTERS ====================
  // Both counters are driven from one number. The site-wide "shopping right now" pill
  // is derived as a subset of the "viewing this right now" count, so the pill can never
  // show more shoppers than viewers — a contradiction on screen reads as fake and costs
  // more trust than the widgets buy.
  const visitorsPillEl = document.getElementById('visitorsPillCount');
  const viewingEl = document.querySelector('[data-live-visitors]');
  if (visitorsPillEl || viewingEl) {
    const PROFILES = {
      sunblock: [18, 7], sunscreen: [18, 7], facewash: [14, 6],
      toner: [9, 4], serum: [7, 4], bundle: [11, 5],
    };
    const handle = (viewingEl && viewingEl.dataset.product) || '';
    let base = 12, variance = 5;
    for (const k in PROFILES) {
      if (handle.indexOf(k) !== -1) { base = PROFILES[k][0]; variance = PROFILES[k][1]; break; }
    }

    let viewers = base + Math.floor(Math.random() * variance);
    const render = () => {
      if (viewingEl) viewingEl.textContent = viewers;
      if (visitorsPillEl) {
        const share = 0.18 + Math.random() * 0.16;           // 18–34% of viewers
        visitorsPillEl.textContent = Math.max(2, Math.min(viewers - 1, Math.round(viewers * share)));
      }
    };
    render();

    const tick = () => {
      viewers += (Math.random() > 0.5 ? 1 : -1);
      viewers = Math.max(base - 3, Math.min(base + variance + 2, viewers));
      render();
      setTimeout(tick, 8000 + Math.random() * 7000);
    };
    setTimeout(tick, 8000);
  }

  // ==================== SHIMMER REMOVAL ON IMAGE LOAD ====================
  document.querySelectorAll('img.lazy-img').forEach(img => {
    const stop = () => img.closest('.product-card__img, .bundle-card__img')?.classList.add('img-loaded');
    if (img.complete && img.naturalWidth > 1) { stop(); }
    else { img.addEventListener('load', stop, { once: true }); }
  });

  // Images used to sit on a 1x1 base64 placeholder until an IntersectionObserver in
  // this file swapped in the real URL. That hid every image URL from the browser's
  // preload scanner, so nothing could start downloading until this script had parsed
  // and run (~920ms on the homepage) — the cards stayed blank until then. They now use
  // native loading="lazy", which the preload scanner sees in the raw HTML.

  // ==================== ANNOUNCEMENT TICKER: constant speed ====================
  {
    // The marquee animates translateX(-50%), so its speed scales with track width —
    // which grows as fonts/emoji load, making the ticker start slow and then race.
    // Lock it to a fixed px/s by deriving the duration from the real width, and
    // re-derive once everything has loaded.
    const track = document.querySelector('.ticker__track');
    if (track) {
      const PX_PER_SEC = 38;
      const setSpeed = () => { track.style.animationDuration = Math.max(20, Math.round(track.scrollWidth / 2 / PX_PER_SEC)) + 's'; };
      setSpeed();
      window.addEventListener('load', setSpeed);
    }
  }

  // ==================== HERO BANNER: drag guard + Best Sellers scroll ====================
  {
    // The banner is a full-screen link on mobile only. Two guards:
    //  1. Desktop has its own Shop Now pill, so the artwork must not navigate at all.
    //     CSS already sets pointer-events: none there; this also catches keyboard Enter.
    //  2. On mobile, only navigate on a genuine tap — if the pointer moved (a scroll or
    //     drag), swallow the click so scrolling never opens the PDP.
    const heroLink = document.getElementById('eviaHeroLink');
    if (heroLink) {
      let sx = 0, sy = 0;
      heroLink.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY; });
      heroLink.addEventListener('click', e => {
        if (window.matchMedia('(min-width: 750px)').matches) { e.preventDefault(); return; }
        if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) e.preventDefault();
      });
    }
    const heroNext = document.getElementById('eviaHeroNext');
    if (heroNext) {
      heroNext.addEventListener('click', () => {
        const heroSection = heroNext.closest('.shopify-section');
        const next = heroSection && heroSection.nextElementSibling;
        if (next) next.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  // ==================== JS ERROR FIXES ====================
  // iOS WKWebView safe wrapper
  window.safePostMessage = function(handler, message) {
    if (window.webkit?.messageHandlers?.[handler]) {
      window.webkit.messageHandlers[handler].postMessage(message);
    }
  };

  // Initial cart load on page open (passive — no UI shift)
  if (cartItemsEl) fetchCart();

  // ==================== HEADER COLOUR SHIFT (ALL PAGES) ====================
  const heroEl = document.getElementById('eviaHero');
  const headerEl = document.getElementById('siteHeader');
  if (headerEl) {
    const updateHeaderMode = () => {
      // Compare against the header's real bottom edge — it sits 36px lower when the
      // announcement ticker is on, so a hardcoded threshold would flip too early.
      const active = heroEl
        ? heroEl.getBoundingClientRect().bottom <= headerEl.getBoundingClientRect().bottom + 4
        : window.scrollY > 60;
      headerEl.classList.toggle('hero-mode', active);
    };
    window.addEventListener('scroll', updateHeaderMode, { passive: true });
    updateHeaderMode();
  }
})();
